module.exports = require("/home/alireza/p/GatsbyProjects/conference-website/website/src/utils/typography.js")


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-plugin-typography/.cache/typography.js
// module id = 381
// module chunks = 231608221292675